import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { FeatureService } from '../../common/feature.service';

@Component({
  selector: 'event-feature-form',
  templateUrl: './event-feature-form.component.html',
  styleUrls: ['./event-feature-form.component.css', '../../app.component.css'],
  providers: [FeatureService]
})
export class EventFeatureFormComponent implements OnInit {

 featureForm: any;
 eventId: any;
 featureId: any;
 feature: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private featureService: FeatureService, private activatedRoute: ActivatedRoute){
  this.featureForm = this.formBuilder.group({
   'id': [''],
   'name': ['', Validators.required],
   'answerType': ['', Validators.required],
  });
  this.feature = this.featureForm.value;
  this.activatedRoute.queryParams.subscribe((params: Params) => {
   this.eventId = params.id;
  });
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveFeature() {
  if(this.featureForm.valid)
  {
   this.spinner = true;
   var params = this.featureForm.value;
   params.eventId = this.eventId;
   this.featureService.saveFeature(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/event-feature-form/event-feature-form.component.ts